var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[_c('Sidebar',{staticClass:"sidebar-container",attrs:{"collapse":_vm.isCollapse}}),_c('div',{staticClass:"main-container",class:{ hasCollapse: _vm.isCollapse }},[_c('Navbar',{attrs:{"is-collapse":_vm.isCollapse},on:{"toggle-collapse":_vm.toggleCollapse}}),_c('AppMain')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }